"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageSources = void 0;
exports.ImageSources = {
    img1920w: 'https://bronson.vwfs.io/bluelabel/img/placeholder/1920x1080.png',
    img1280w: 'https://bronson.vwfs.io/bluelabel/img/placeholder/1280x720.png',
    img960w: 'https://bronson.vwfs.io/bluelabel/img/placeholder/960x540.png',
    img720w: 'https://bronson.vwfs.io/bluelabel/img/placeholder/720x405.png',
    img480w: 'https://bronson.vwfs.io/bluelabel/img/placeholder/480x270.png',
};
